export default {
  VDTPT : 1, // Vốn đầu tư phát triển
  KPSN : 2, // Kinh phí sự nghiệp
  CCTL : 3 // CCTL
};